export default  [
    {
        id: 1234,
        reference: '6ano',
        price: 120,
        title: '6° Ano',
        duration: 18000,
        lessonsQuant: 12,
        topics: [
            {
                id: 11,
                title: 'Introdução aos Números Inteiros',
                lessons:
                    [
                        { title: 'Aula 1', url: 'aula1.com', id: 1},
                        { title: 'Aula 2', url: 'aula2.com', id: 2},
                        { title: 'Aula 3', url: 'aula3.com',id: 3 },
                        { title: 'Aula 4', url: 'aula4.com',id: 4 },
                    ]
            },
            {
                id: 22,
                title: 'Potencição',
                lessons:
                    [
                        { title: 'Aula 5', url: 'aula5.com', id: 5},
                        { title: 'Aula 6', url: 'aula6.com', id: 6 },
                        { title: 'Aula 7', url: 'aula7.com', id: 7 },
                        { title: 'Aula 8', url: 'aula8.com', id: 8 },
                    ]
            },
            {
                id: 33,
                title: 'Radiciação',
                lessons:
                    [
                        { title: 'Aula 9', url: 'aula9.com', id: 9 },
                        { title: 'Aula 10', url: 'aula10.com', id: 10 },
                        { title: 'Aula 11', url: 'aula11.com', id: 11 },
                        { title: 'Aula 12', url: 'aula12.com', id: 12 },
                    ]
            }
        ]
    },
    
    
    
    
    {
        id: 4321,
        title: 'Curso 2',
        topics: [
            {
                title: 'Topico-3',
                lessons:
                    [
                        { title: 'Aula 9', url: 'aula9.com' },
                        { title: 'Aula 10', url: 'aula10.com' },
                        { title: 'Aula 11', url: 'aula11.com' },
                        { title: 'Aula 12', url: 'aula12.com' },
                    ]
            },
            {
                title: 'Topico-4',
                lessons:
                    [
                        { title: 'Aula 13', url: 'aula13.com' },
                        { title: 'Aula 14', url: 'aula14.com' },
                        { title: 'Aula 15', url: 'aula15.com' },
                        { title: 'Aula 16', url: 'aula16.com' },
                    ]
            },
        ]
    },
    {
        id: 4444,
        title: 'Curso 3',
        topics: [
            {
                title: 'Topico-5',
                lessons:
                    [
                        { title: 'Aula 17', url: 'aula17.com' },
                        { title: 'Aula 18', url: 'aula18.com' },
                        { title: 'Aula 19', url: 'aula19.com' },
                        { title: 'Aula 20', url: 'aula20.com' },
                    ]
            },
            {
                title: 'Topico-6',
                lessons:
                    [
                        { title: 'Aula 21', url: 'aula21.com' },
                        { title: 'Aula 22', url: 'aula22.com' },
                        { title: 'Aula 23', url: 'aula23.com' },
                        { title: 'Aula 24', url: 'aula24.com' },
                    ]
            },
        ]
    },
]